export default __webpack_public_path__ + "static/media/mufg.149b00af.svg";